import { log } from 'log';

export const parseMessage = (event: MessageEvent): any | null => {
    try {
        if (event?.data) {
            log('info', '[UCIP]: Receive: ', event.data);
            return JSON.parse(event.data);
        }
    } catch (e) {
        log('warn', '[UCIP]: Post message cannot be parsed: ', event);
    }
};

export const sendMessage = (
    message: object,
    iframeClass: string = 'game-iframe'
): void => {
    try {
        const iframe = document.querySelector<HTMLIFrameElement>(`.${iframeClass}`);
        if (!iframe) {
            log('warn', `[UCIP]: No iframe found with class ${iframeClass}`);
            return;
        }
        const json = JSON.stringify(message);
        iframe.contentWindow?.postMessage(json, '*');

        log('info', '[UCIP]: Sent: ', json);
    } catch (e) {
        log('error', '[UCIP]: Post message cannot be sent: ', message);
    }
};
